// extracted by mini-css-extract-plugin
export default {"resetButton":"nwIwDqg","root":"lmMXzvr","avatar":"oxgZoYM","avatarLetter":"kawW5sb","highlight":"u83FP62","highlightRow":"UktUWzX"};